import(/* webpackChunkName: "createApp" */ './createApp').then(createApp => createApp.createApp())